/**
 * returns a list of active tests from the window object, defined by Adobe Target, or an empty array
 */
export const getActiveTests = () => {
  return (window?.tests || []).map(test => test.toLowerCase());
};

export const getIsAdobeScriptLoaded = () => {
  return window?.adobeScriptLoaded ?? false;
};
